﻿﻿import { IProductCenter } from './product-center';
import { IContact } from './contact';
import { IUser } from './user';

export interface IProductCenterContact {
    id: number;
    productCenter: IProductCenter;
    contact: IContact;
    notes: string;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
    createdByUser: IUser;
    updatedByUser: IUser;
}
